import React, { Component } from 'react'
import { NameContainer } from '../../Commons/Name'
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { translateFormFieldLabel } from '../../../../../../../helpers/collaborativeIndexations'
import { YearContainer } from '../../Commons/Year'
import { AgeContainer } from '../../Commons/Age'

class Identity extends Component
{
    static propTypes = {
        t: PropTypes.func.isRequired,
    }

    render()
    {
        const { t } = this.props

        return (
            <div className={"population-census"}>
                <div>
                    { t("visualizer:toolbar.left.collaborativeIndexationCreation.form.population_census.steps.identity.title") }
                    <NameContainer hasFocus={true} />
                </div>
                <YearContainer fieldName={"birthYear"} label={translateFormFieldLabel(t, "birthYear")}/>
                <div data-content={t("visualizer:common.or")} className={"separator"} />
                <AgeContainer />
            </div>
        )
    }
}

export default withTranslation()(Identity)
